import "core-js/modules/es6.function.bind";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import adaptRequest from "./requestAdapter";
import adaptResponse from "./responseAdapter";
import request from "./request";
import { version } from "../package.json";

function _get(engineKey, path, params) {
  var headers = new Headers({
    "x-swiftype-integration": "search-ui",
    "x-swiftype-integration-version": version
  });
  var query = Object.entries(_objectSpread({
    engine_key: engineKey
  }, params)).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        paramName = _ref2[0],
        paramValue = _ref2[1];

    return "".concat(paramName, "=").concat(encodeURIComponent(paramValue));
  }).join("&");
  return fetch("https://search-api.swiftype.com/api/v1/public/".concat(path, "?").concat(query), {
    method: "GET",
    credentials: "include",
    headers: headers
  });
}

var SiteSearchAPIConnector = /*#__PURE__*/function () {
  /**
   * @callback next
   * @param {Object} updatedQueryOptions The options to send to the API
   */

  /**
   * @callback hook
   * @param {Object} queryOptions The options that are about to be sent to the API
   * @param {next} next The options that are about to be sent to the API
   */

  /**
   * @typedef Options
   * @param  {string} documentType Document Type found in your Site Search Dashboard
   * @param  {string} engineKey Credential found in your Site Search Dashboard
   * @param  {hook} beforeSearchCall=(queryOptions,next)=>next(queryOptions) A hook to amend query options before the request is sent to the
   *   API in a query on an "onSearch" event.
   * @param  {hook} beforeAutocompleteResultsCall=(queryOptions,next)=>next(queryOptions) A hook to amend query options before the request is sent to the
   *   API in a "results" query on an "onAutocomplete" event.
   */

  /**
   * @param {Options} options
   */
  function SiteSearchAPIConnector(_ref3) {
    var documentType = _ref3.documentType,
        engineKey = _ref3.engineKey,
        _ref3$beforeSearchCal = _ref3.beforeSearchCall,
        beforeSearchCall = _ref3$beforeSearchCal === void 0 ? function (queryOptions, next) {
      return next(queryOptions);
    } : _ref3$beforeSearchCal,
        _ref3$beforeAutocompl = _ref3.beforeAutocompleteResultsCall,
        beforeAutocompleteResultsCall = _ref3$beforeAutocompl === void 0 ? function (queryOptions, next) {
      return next(queryOptions);
    } : _ref3$beforeAutocompl;

    _classCallCheck(this, SiteSearchAPIConnector);

    this.documentType = documentType;
    this.engineKey = engineKey;
    this.beforeSearchCall = beforeSearchCall;
    this.beforeAutocompleteResultsCall = beforeAutocompleteResultsCall;
    this.request = request.bind(this, engineKey);
    this._get = _get.bind(this, engineKey);
  }

  _createClass(SiteSearchAPIConnector, [{
    key: "onResultClick",
    value: function onResultClick(_ref4) {
      var query = _ref4.query,
          documentId = _ref4.documentId,
          tags = _ref4.tags;

      if (tags && tags.length > 0) {
        console.warn("search-ui-site-search-connector: Site Search does not support tags on click");
      }

      this._get("analytics/pc", {
        t: new Date().getTime(),
        q: query,
        doc_id: documentId
      });
    }
  }, {
    key: "onAutocompleteResultClick",
    value: function onAutocompleteResultClick(_ref5) {
      var query = _ref5.query,
          documentId = _ref5.documentId,
          tags = _ref5.tags;

      if (tags) {
        console.warn("search-ui-site-search-connector: Site Search does not support tags on autocompleteClick");
      }

      this._get("analytics/pas", {
        t: new Date().getTime(),
        q: query,
        doc_id: documentId
      });
    }
  }, {
    key: "onSearch",
    value: function onSearch(state, queryConfig) {
      var _this = this;

      var options = adaptRequest(state, queryConfig, this.documentType);
      return this.beforeSearchCall(options, function (newOptions) {
        return _this.request("POST", "engines/search.json", newOptions).then(function (json) {
          return adaptResponse(json, _this.documentType);
        });
      });
    }
  }, {
    key: "onAutocomplete",
    value: function () {
      var _onAutocomplete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref6, queryConfig) {
        var _this2 = this;

        var searchTerm, options;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                searchTerm = _ref6.searchTerm;

                if (!queryConfig.results) {
                  _context.next = 4;
                  break;
                }

                options = adaptRequest({
                  searchTerm: searchTerm
                }, queryConfig.results, this.documentType);
                return _context.abrupt("return", this.beforeAutocompleteResultsCall(options, function (newOptions) {
                  return _this2.request("POST", "engines/suggest.json", newOptions).then(function (json) {
                    return {
                      autocompletedResults: adaptResponse(json, _this2.documentType).results
                    };
                  });
                }));

              case 4:
                if (queryConfig.suggestions) {
                  console.warn("search-ui-site-search-connector: Site Search does support query suggestions on autocomplete");
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onAutocomplete(_x, _x2) {
        return _onAutocomplete.apply(this, arguments);
      }

      return onAutocomplete;
    }()
  }]);

  return SiteSearchAPIConnector;
}();

export default SiteSearchAPIConnector;